import React, { useState } from 'react';
import { Image } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { MediaPicker } from './MediaPicker';

interface ImageInputProps {
  label?: string;
  value: string | null;
  onChange: (url: string | null) => void;
  hint?: string;
  className?: string;
}

export function ImageInput({ label, value, onChange, hint, className }: ImageInputProps) {
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-foreground mb-1.5">
          {label}
        </label>
      )}

      {value ? (
        <div className="relative group rounded-lg overflow-hidden border border-border">
          <img
            src={value}
            alt=""
            className="w-full h-40 object-cover"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100">
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setPickerOpen(true)}
            >
              Change
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => onChange(null)}
            >
              Remove
            </Button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setPickerOpen(true)}
          className="w-full h-32 border-2 border-dashed border-border rounded-lg flex flex-col items-center justify-center gap-2 text-muted-foreground hover:border-primary hover:text-foreground transition-colors"
        >
          <Image className="h-8 w-8" />
          <span className="text-sm">Select Image</span>
        </button>
      )}

      {hint && (
        <p className="mt-1 text-xs text-muted-foreground">{hint}</p>
      )}

      <MediaPicker
        isOpen={pickerOpen}
        onClose={() => setPickerOpen(false)}
        onSelect={(media) => onChange(media.url)}
      />
    </div>
  );
}
